import React, { useRef } from 'react';
import { Typography } from '@material-ui/core';
import { GetApp, Cancel, AttachFile } from '@material-ui/icons';
import { TextButton, Button } from 'm2m.components';
import { defaultAcceptableFileTypes } from 'components/uploadDocs';
import { v4 as uuid } from 'uuid';
import {
  OfertaPrimariaStatus,
  OfertaPrimariaInvestidorResponse,
  Comprovante,
  OperacaoStatus,
} from 'common/genericTypes';

interface Props {
  investidor: OfertaPrimariaInvestidorResponse;
  anexo?: Comprovante;
  status: OperacaoStatus;
  onDownload: (comprovanteId: string) => void;
  onAdd: (anexo: Comprovante) => void;
  onDelete: (anexo: Comprovante) => void;
  onGestaoComprovantes?: () => void;
}

const ComprovanteComponent: React.FC<Props> = (props) => {
  const { investidor, anexo, status, onDownload, onAdd, onDelete, onGestaoComprovantes } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  const handleAnexoDelete = () => {
    onDelete(anexo!);
  };

  const openFileDialog = () => {
    inputRef?.current?.click();
  };

  const isValidFileType = (file: File): boolean => {
    return defaultAcceptableFileTypes.some((type) => file.type === type);
  };

  const onInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files ? Array.from(event.target.files) : [];
    if (!files.length) return;

    files.forEach((file) => {
      if (!isValidFileType(file)) return;

      const newAttachment: Comprovante = {
        id: uuid(),
        investidorId: investidor.investidorId,
        file,
      };

      onAdd(newAttachment);
    });
  };

  if (status === OfertaPrimariaStatus.AguardandoConfirmacao) {
    if (anexo) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', maxWidth: '100%' }}>
          <div style={{ overflow: 'hidden' }}>
            <Typography variant="subtitle1">{anexo.file?.name ?? anexo.remoteFileInfo?.fileName ?? ''}</Typography>
          </div>
          <TextButton onClick={() => handleAnexoDelete()} startIcon={<Cancel />}>
            {'Remover'}
          </TextButton>
        </div>
      );
    } else {
      return (
        <div>
          <TextButton onClick={openFileDialog}>{'Anexar Comprovante'}</TextButton>
          <input
            ref={inputRef}
            type="file"
            accept={defaultAcceptableFileTypes.join(',')}
            multiple
            style={{ display: 'none' }}
            onChange={onInputChange}
          />
        </div>
      );
    }
  } else {
    if (investidor.comprovanteId) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', alignContent: 'flex-end', textAlign: 'right' }}>
          <Button startIcon={<GetApp />} onClick={() => onDownload(investidor.comprovanteId!)} variant="text">
            {'Download'}
          </Button>
        </div>
      );
    } else {
      if (onGestaoComprovantes) {
        return (
          <Button
            startIcon={<AttachFile />}
            onClick={onGestaoComprovantes}
            variant="text"
          >
            {'Gestão de Comprovantes'}
          </Button>
        );
      }
      return <Typography variant="body2">{'Sem comprovante.'}</Typography>;
    }
  }
};

export default ComprovanteComponent;
